import { MainLayout } from 'shared/ui/layout/main';

import { Tabs } from '../tabs';

export function UsersGroupsLayout() {
  return <MainLayout tabs={<Tabs />} />;
}
